import { render, staticRenderFns } from "./technology.vue?vue&type=template&id=15362cd3&scoped=true&"
import script from "./technology.vue?vue&type=script&lang=js&"
export * from "./technology.vue?vue&type=script&lang=js&"
import style0 from "./technology.vue?vue&type=style&index=0&id=15362cd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15362cd3",
  null
  
)

export default component.exports